import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Leaf, Loader2 } from "lucide-react";
import api from "@/lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("rmb_token")) nav("/admin/dashboard");
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("rmb_token", data.token);
      nav("/admin/dashboard");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-5" data-testid="admin-login-page">
      <div className="w-full max-w-sm rounded-2xl border border-border bg-card p-8">
        <div className="flex items-center gap-2.5">
          <img src="/logo-bins-plus.png" alt="Bins Plus Pressure Washing" className="h-11 w-11 object-contain" />
          <div className="leading-tight">
            <span className="block font-heading text-lg font-extrabold">Bins Plus Pressure Washing</span>
            <span className="block text-xs font-semibold text-muted-foreground">Owner Login</span>
          </div>
        </div>
        <p className="mt-2 text-sm text-muted-foreground">Sign in to manage bookings & routes.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="text-sm font-semibold">Email</label>
            <input data-testid="admin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full rounded-xl border border-border bg-muted/50 px-4 py-3 focus:bg-card focus:outline-none focus:ring-2 focus:ring-primary" />
          </div>
          <div>
            <label className="text-sm font-semibold">Password</label>
            <input data-testid="admin-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="mt-1 w-full rounded-xl border border-border bg-muted/50 px-4 py-3 focus:bg-card focus:outline-none focus:ring-2 focus:ring-primary" />
          </div>
          {error && <p data-testid="admin-login-error" className="text-sm font-semibold text-destructive">{error}</p>}
          <button data-testid="admin-login-submit" type="submit" disabled={loading}
            className="inline-flex w-full items-center justify-center gap-2 rounded-xl bg-primary px-7 py-3.5 font-bold text-primary-foreground transition-all hover:brightness-110 disabled:opacity-50">
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
